export const LEGAL_DOCUMENTS = {
  privacy: {
    id: "privacy",
    title: "Privacy Policy",
    updated: "May 2026",
    sections: [
      {
        heading: "Overview",
        body: "PagePeers respects your privacy. This policy explains what we collect when you use pagepeers.com and PagePeers Club, how we use it, and the choices you have.",
      },
      {
        heading: "Information we collect",
        body: "We may collect your name, email address, shelf and reading activity, circle participation, messages you send within the product, and technical data such as browser type and approximate region. If you contact us, we store the content of your enquiry.",
      },
      {
        heading: "How we use information",
        body: "We use your information to operate accounts, personalize shelves and circles, improve the product, respond to support requests, and send service-related notices. We do not sell your personal reading data to advertisers.",
      },
      {
        heading: "Sharing",
        body: "We share data with service providers who help us host, secure, and deliver the product — under contracts that limit their use. We may disclose information if required by law or to protect users and the platform.",
      },
      {
        heading: "Retention & security",
        body: "We keep information while your account is active and for a reasonable period afterward. We apply technical and organizational measures appropriate to the data we hold.",
      },
      {
        heading: "Your rights",
        body: "Depending on where you live, you may request access, correction, deletion, or export of your data. Contact support@pagepeers.com and we will respond within applicable timeframes.",
      },
      {
        heading: "Contact",
        body: "Questions about privacy: support@pagepeers.com.",
      },
    ],
  },
  terms: {
    id: "terms",
    title: "Terms of Service",
    updated: "May 2026",
    sections: [
      {
        heading: "Agreement",
        body: "By using PagePeers websites and apps, you agree to these Terms. If you do not agree, please do not use the service.",
      },
      {
        heading: "Accounts",
        body: "You are responsible for your account credentials and activity under your account. Provide accurate information and notify us of unauthorized use.",
      },
      {
        heading: "Acceptable use",
        body: "Use PagePeers lawfully and respectfully. Do not harass others, post unlawful content, attempt to breach security, scrape at scale without permission, or misuse lending or circle features.",
      },
      {
        heading: "Content & shelves",
        body: "You retain rights to content you submit. You grant PagePeers a license to host, display, and process that content to operate the service. Curated shelves and editorial materials are owned by PagePeers or licensors.",
      },
      {
        heading: "Lending & community",
        body: "Book lending between members is arranged by users. PagePeers facilitates tools but is not responsible for physical loss, damage, or disputes — exercise judgment as you would in any book club.",
      },
      {
        heading: "Availability",
        body: "We may modify, suspend, or discontinue features with reasonable notice where practical. The service is provided “as is” to the extent permitted by law.",
      },
      {
        heading: "Contact",
        body: "Questions about these Terms: support@pagepeers.com.",
      },
    ],
  },
  cookies: {
    id: "cookies",
    title: "Cookie Policy",
    updated: "May 2026",
    sections: [
      {
        heading: "What are cookies?",
        body: "Cookies are small text files stored on your device. We also use similar technologies such as local storage for preferences and session state.",
      },
      {
        heading: "How we use cookies",
        body: "Essential cookies and storage keep you signed in, remember theme preferences, and protect the site. Analytics cookies, if enabled, help us understand how readers use the public site so we can improve it.",
      },
      {
        heading: "Your choice",
        body: "You can accept all cookies, reject non-essential cookies, or change your mind later by opening this policy from the footer. Rejecting non-essential cookies will not block access to the public site.",
      },
      {
        heading: "Managing cookies",
        body: "Most browsers let you delete or block cookies in settings. Blocking essential cookies may affect sign-in and core features on PagePeers Club.",
      },
      {
        heading: "Contact",
        body: "Questions about cookies: support@pagepeers.com.",
      },
    ],
  },
};

export const COOKIE_CONSENT_KEY = "pp_cookie_consent";
